import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import set from "lodash-es/set";

export const subscribeAndSave: ComponentTemplate = {
  id: "25299112-b0aa-4528-a2cc-bedcb4c8968f",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Subscribe & Save",
  leftBarCategory: { main: "product", subCategory: "sellingPlans" },
  preview: "product/subscribeAndSave.svg",
  transforms: [
    (component: any, parent: any) => {
      if (parent?.type === "container" && parent.children?.length === 0) {
        set(component, "props.style.flexGrow", 1);
      }
      return component;
    },
  ],
  template: {
    id: "09531305-6582-4c75-8a22-4dfe6d1caf2f",
    name: "Subscribe & Save",
    type: "selectionList",
    props: {
      style: {
        __width: "50%",
        display: "flex",
        __flexGap: "10px",
        alignSelf: "stretch",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "space-between",
      },
      _accessibilitySelection: true,
    },
    children: [
      {
        id: "bede1a07-f2e5-46e8-ab0c-5b82c95f0db1",
        name: "One-time Purchase",
        type: "container",
        props: {
          style: {
            color: "#000000FF",
            display: "flex",
            flexGrow: 1,
            __flexGap: "12px",
            alignSelf: "stretch",
            alignItems: "center",
            paddingTop: "12px",
            paddingLeft: "12px",
            paddingRight: "12px",
            paddingBottom: "12px",
            borderTopColor: "#4F4F4FFF",
            borderTopStyle: "solid",
            borderTopWidth: "2px",
            justifyContent: "flex-start",
            backgroundColor: "#FFFFFFFF",
            borderLeftColor: "#4F4F4FFF",
            borderLeftStyle: "solid",
            borderLeftWidth: "2px",
            borderRightColor: "#4F4F4FFF",
            borderRightStyle: "solid",
            borderRightWidth: "2px",
            borderBottomColor: "#4F4F4FFF",
            borderBottomStyle: "solid",
            borderBottomWidth: "2px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            __animateVariantTransitions: true,
          },
          onClick: [
            {
              id: "78edc657-4ca6-47c8-89d9-94e758dccb67",
              type: "setActiveSellingPlan",
              value: {
                sellingPlanId: {
                  __reploOneTimePurchase: true,
                },
              },
            },
          ],
        },
        children: [
          {
            id: "1ad39841-5252-4f0b-9ebc-73e869c2eed8",
            name: "Radio",
            type: "container",
            props: {
              style: {
                width: "24px",
                height: "24px",
                __width: "24px",
                display: "flex",
                __height: "24px",
                maxWidth: "100%",
                __flexGap: "10px",
                alignItems: "center",
                flexDirection: "column",
                borderTopColor: "#14433DFF",
                borderTopStyle: "solid",
                borderTopWidth: "2px",
                justifyContent: "center",
                borderLeftColor: "#14433DFF",
                borderLeftStyle: "solid",
                borderLeftWidth: "2px",
                borderRightColor: "#14433DFF",
                borderRightStyle: "solid",
                borderRightWidth: "2px",
                borderBottomColor: "#14433DFF",
                borderBottomStyle: "solid",
                borderBottomWidth: "2px",
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                borderBottomLeftRadius: "50%",
                borderBottomRightRadius: "50%",
              },
            },
            children: [
              {
                id: "5eb3ad05-e4ff-4bd0-9995-bec67f413826",
                name: "Circle 1",
                type: "circle",
                props: {
                  style: {
                    color: "#FFFFFFFF",
                    width: "14px",
                    height: "14px",
                    __width: "14px",
                    display: "flex",
                    __height: "14px",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#14433D00",
                    borderTopLeftRadius: "50%",
                    borderTopRightRadius: "50%",
                    borderBottomLeftRadius: "50%",
                    borderBottomRightRadius: "50%",
                  },
                },
                children: [],
              },
            ],
          },
          {
            id: "9e2431ef-858a-4172-a956-db0ea1366887",
            name: "Content",
            type: "container",
            props: {
              style: {
                display: "flex",
                maxWidth: "100%",
                __flexGap: "8px",
                alignSelf: "stretch",
                alignItems: "flex-start",
                flexDirection: "column",
                justifyContent: "flex-start",
              },
            },
            children: [
              {
                id: "69d2600d-2948-40b1-80be-38e1405f8f23",
                type: "text",
                props: {
                  text: "<p>One-time purchase</p>",
                  style: {
                    color: "#464646FF",
                    fontSize: "16px",
                    alignSelf: "stretch",
                    fontWeight: "600",
                    lineHeight: "20px",
                    letterSpacing: "2px",
                  },
                },
              },
              {
                id: "fc7177b2-6e43-482e-9f4e-8771be05af99",
                name: "Content",
                type: "container",
                props: {
                  style: {
                    display: "flex",
                    maxWidth: "100%",
                    __flexGap: "10px",
                    alignSelf: "stretch",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                },
                children: [
                  {
                    id: "890755b7-1a84-4e7c-a119-a6dfea0a63df",
                    name: "Price without Selling Plan",
                    type: "text",
                    props: {
                      text: "{{attributes._variant.displayPriceWithoutSellingPlanDiscount}}",
                      style: {
                        color: "#5C5C5CFF",
                        fontSize: "12px",
                        textAlign: "left",
                        fontWeight: "600",
                        lineHeight: "14px",
                      },
                      "style@md": {
                        fontSize: "14px",
                        lineHeight: "18px",
                      },
                    },
                  },
                ],
              },
            ],
          },
        ],
        variants: [
          {
            id: "89d1d857-b802-47d4-9d46-885231138dff",
            name: "default",
            query: null,
            componentOverrides: null,
          },
          {
            id: "4aa3faff-57bf-43b6-8930-baff83064d7f",
            name: "Selected List Item",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "fde26c5f-3ebe-4607-965b-f0e4aa350826",
                  field: "state.selectionList.isItemSelected",
                },
              ],
            },
            componentOverrides: null,
          },
          {
            id: "6bbc2f73-005f-49fe-b57a-371a1b17ec30",
            name: "Hover",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "cc613a33-1068-446e-9e94-d7f07cda9a39",
                  field: "interaction.hover",
                },
              ],
            },
            componentOverrides: null,
          },
        ],
        variantOverrides: {
          "6bbc2f73-005f-49fe-b57a-371a1b17ec30": {
            componentOverrides: {
              "1ad39841-5252-4f0b-9ebc-73e869c2eed8": {
                props: {
                  style: {
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                  },
                },
              },
              "bede1a07-f2e5-46e8-ab0c-5b82c95f0db1": {
                props: {
                  style: {
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                    backgroundColor: "#F6F6F6FF",
                    __alchemyGradient__backgroundColor__tilt: null,
                    __alchemyGradient__backgroundColor__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
              "890755b7-1a84-4e7c-a119-a6dfea0a63df": {
                props: {
                  style: {
                    color: "#000000FF",
                    __alchemyGradient__color__tilt: null,
                    __alchemyGradient__color__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
            },
          },
          "4aa3faff-57bf-43b6-8930-baff83064d7f": {
            componentOverrides: {
              "1ad39841-5252-4f0b-9ebc-73e869c2eed8": {
                props: {
                  style: {
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                  },
                },
              },
              "09fad59d-d44b-4770-9633-9cb2b0a9b546": {
                props: {
                  style: {
                    backgroundColor: "#14433DFF",
                  },
                },
              },
              "69d2600d-2948-40b1-80be-38e1405f8f23": {
                props: {
                  style: {
                    letterSpacing: "0px",
                  },
                },
              },
              "bede1a07-f2e5-46e8-ab0c-5b82c95f0db1": {
                props: {
                  style: {
                    color: null,
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    backgroundColor: "#F6F6F6FF",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                    __alchemyGradient__backgroundColor__tilt: null,
                    __alchemyGradient__backgroundColor__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
              "5eb3ad05-e4ff-4bd0-9995-bec67f413826": {
                props: {
                  style: {
                    backgroundColor: "#000000FF",
                    __reploGradient__color__design_library: null,
                    __alchemyGradient__backgroundColor__tilt: null,
                    __alchemyGradient__backgroundColor__stops: null,
                  },
                },
              },
            },
          },
        },
      },
      {
        id: "b2286d50-8be5-4c69-a860-8a12ac7373a4",
        name: "Subscribe",
        type: "container",
        props: {
          style: {
            color: "#000000FF",
            cursor: "default",
            display: "flex",
            maxWidth: "100%",
            __flexGap: "16px",
            alignSelf: "stretch",
            alignItems: "flex-start",
            paddingTop: "12px",
            paddingLeft: "12px",
            paddingRight: "12px",
            flexDirection: "column",
            paddingBottom: "12px",
            borderTopColor: "#4F4F4FFF",
            borderTopStyle: "solid",
            borderTopWidth: "2px",
            justifyContent: "space-between",
            backgroundColor: "#FFFFFFFF",
            borderLeftColor: "#4F4F4FFF",
            borderLeftStyle: "solid",
            borderLeftWidth: "2px",
            borderRightColor: "#4F4F4FFF",
            borderRightStyle: "solid",
            borderRightWidth: "2px",
            borderBottomColor: "#4F4F4FFF",
            borderBottomStyle: "solid",
            borderBottomWidth: "2px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            __animateVariantTransitions: true,
          },
          onClick: [
            {
              id: "8cb4fd69-b79a-4446-8fcf-69f529fe7eee",
              type: "setActiveSellingPlan",
              value: {
                sellingPlanId: {
                  __reploOneTimePurchase: true,
                },
              },
            },
          ],
        },
        children: [
          {
            id: "ac184ac7-e5fc-4785-aec8-61d12e571ce3",
            name: "Title and Price",
            type: "container",
            props: {
              style: {
                display: "flex",
                maxWidth: "100%",
                __flexGap: "10px",
                alignSelf: "stretch",
                alignItems: "center",
                justifyContent: "flex-start",
              },
            },
            children: [
              {
                id: "5650010a-be8e-4852-b98d-01cbd87f0e8d",
                name: "Active",
                type: "container",
                props: {
                  style: {
                    width: "24px",
                    height: "24px",
                    __width: "24px",
                    display: "flex",
                    __height: "24px",
                    maxWidth: "100%",
                    __flexGap: "10px",
                    alignItems: "center",
                    flexDirection: "column",
                    borderTopColor: "#14433DFF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    justifyContent: "center",
                    borderLeftColor: "#14433DFF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#14433DFF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#14433DFF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                    borderTopLeftRadius: "50%",
                    borderTopRightRadius: "50%",
                    borderBottomLeftRadius: "50%",
                    borderBottomRightRadius: "50%",
                  },
                },
                children: [
                  {
                    id: "09fad59d-d44b-4770-9633-9cb2b0a9b546",
                    name: "Circle 2",
                    type: "circle",
                    props: {
                      style: {
                        color: "#FFFFFFFF",
                        width: "14px",
                        height: "14px",
                        __width: "14px",
                        display: "flex",
                        __height: "14px",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#14433D00",
                        borderTopLeftRadius: "50%",
                        borderTopRightRadius: "50%",
                        borderBottomLeftRadius: "50%",
                        borderBottomRightRadius: "50%",
                      },
                    },
                    children: [],
                  },
                ],
              },
              {
                id: "bf16b920-92e9-4ed2-b20b-8bf6811a3471",
                name: "Content",
                type: "container",
                props: {
                  style: {
                    display: "flex",
                    flexGrow: 1,
                    maxWidth: "100%",
                    __flexGap: "8px",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  },
                },
                children: [
                  {
                    id: "4cc33fae-82b4-4a5d-95a8-6f411efe6606",
                    name: "Content",
                    type: "container",
                    props: {
                      style: {
                        display: "flex",
                        maxWidth: "100%",
                        __flexGap: "8px",
                        alignSelf: "stretch",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      },
                    },
                    children: [
                      {
                        id: "f88344ad-f91d-4126-a41d-c6d47cecfa5d",
                        type: "text",
                        props: {
                          text: "<p>Subscribe and Save</p>",
                          style: {
                            color: "#464646FF",
                            fontSize: "16px",
                            alignSelf: "stretch",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0px",
                          },
                          "style@sm": {
                            height: "auto",
                            alignSelf: "auto",
                          },
                        },
                      },
                    ],
                  },
                  {
                    id: "995c6cb5-1138-439c-be58-c8747177b454",
                    name: "Content",
                    type: "container",
                    props: {
                      style: {
                        display: "flex",
                        maxWidth: "100%",
                        __flexGap: "8px",
                        alignSelf: "stretch",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                      },
                    },
                    children: [
                      {
                        id: "aa46b7f7-7749-49d4-816b-074e5ae0afff",
                        name: "Content",
                        type: "container",
                        props: {
                          style: {
                            display: "flex",
                            maxWidth: "100%",
                            __flexGap: "16px",
                            alignSelf: "stretch",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          },
                        },
                        children: [
                          {
                            id: "4ab82a6f-822a-4b95-979f-9f94b0bdbf27",
                            name: "Price",
                            type: "text",
                            props: {
                              text: "{{attributes._variant.displayPrice}}",
                              style: {
                                color: "#686868FF",
                                fontSize: "12px",
                                textAlign: "left",
                                fontWeight: "600",
                                lineHeight: "14px",
                                letterSpacing: "0px",
                              },
                              "style@md": {
                                fontSize: "14px",
                                lineHeight: "18px",
                              },
                            },
                          },
                          {
                            id: "c1d5d542-3b68-4967-9e7e-1cc245284e3c",
                            name: "Price",
                            type: "text",
                            props: {
                              text: "{{attributes._variant.compareAtDisplayPrice}}",
                              style: {
                                color: "#14433DFF",
                                fontSize: "12px",
                                textAlign: "left",
                                fontWeight: "300",
                                lineHeight: "14px",
                                letterSpacing: "0px",
                                textDecoration: "line-through",
                              },
                              "style@md": {
                                fontSize: "14px",
                                lineHeight: "18px",
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "a5eed9b0-7dbd-44cb-99a6-fc11a1a42ef2",
            name: "Selling Plan List Dropdown Container",
            type: "container",
            props: {
              style: {
                color: "#000000FF",
                display: "none",
                flexGrow: 1,
                maxWidth: "100%",
                __display: "flex",
                __flexGap: "24px",
                alignSelf: "stretch",
                alignItems: "flex-start",
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "#FCFCFCFF",
              },
              "style@md": {
                display: "none",
                __display: "flex",
              },
              "style@sm": {
                display: "none",
                __display: "flex",
              },
            },
            children: [
              {
                id: "30395ae4-cfcd-4d73-a382-e9339a49b2f7",
                name: "Selling Plan Dropdown 1",
                type: "sellingPlanSelectDropdown",
                props: {
                  style: {
                    zIndex: "2",
                    fontSize: "16px",
                    alignSelf: "stretch",
                    fontWeight: 700,
                    paddingTop: "12px",
                    borderColor: "rgb(0, 0, 0)",
                    borderWidth: "1px",
                    paddingLeft: "12px",
                    paddingRight: "24px",
                    paddingBottom: "12px",
                    borderTopStyle: "solid",
                    borderLeftStyle: "solid",
                    borderRightStyle: "solid",
                    borderBottomStyle: "solid",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  },
                  _includeOneTimePurchase: false,
                  _hideDefaultArrowDisplay: true,
                },
              },
              {
                id: "01036097-337b-456d-a603-ca406405a28c",
                name: "Arrow",
                type: "icon",
                props: {
                  style: {
                    top: "50%",
                    right: "2px",
                    width: "24px",
                    height: "24px",
                    zIndex: 1,
                    position: "absolute",
                    __transform: {
                      skewX: "0deg",
                      skewY: "0deg",
                      scaleX: "100%",
                      scaleY: "100%",
                      scaleZ: "100%",
                      rotateX: "0deg",
                      rotateY: "0deg",
                      rotateZ: "0deg",
                      translateX: "0px",
                      translateY: "-50%",
                      translateZ: "0px",
                    },
                  },
                  iconName: "chevron-down",
                },
              },
            ],
          },
        ],
        variants: [
          {
            id: "ed7dcfaf-22e4-46a1-8ed4-850edcdad4c5",
            name: "default",
            query: null,
            componentOverrides: null,
          },
          {
            id: "08cc8a80-ea86-44ad-910b-2ddd05fbbf70",
            name: "Selected List Item",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "3c43ef1c-4465-44f5-942d-5653e84ee6b1",
                  field: "state.selectionList.isItemSelected",
                },
              ],
            },
            componentOverrides: null,
          },
          {
            id: "d05ee808-feb8-4332-9c36-d89b92332215",
            name: "Hover",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "8618df2d-462e-4ade-a8dc-9d2141263eea",
                  field: "interaction.hover",
                },
              ],
            },
            componentOverrides: null,
          },
        ],
        variantOverrides: {
          "08cc8a80-ea86-44ad-910b-2ddd05fbbf70": {
            componentOverrides: {
              "1516a7a7-80d7-487b-ae9b-17f6cd01de77": {
                props: {
                  style: {
                    maxWidth: "20px",
                    __imageSource:
                      "https://cdn.shopify.com/s/files/1/0771/0860/9337/files/icon_-_save_15.png?v=1731235197",
                    __imageAltText: "I'm sorry, I can't check URLs.",
                  },
                  loading: "lazy",
                },
              },
              "233140db-5145-47a8-b1a5-f3e99417c04b": {
                props: {
                  style: {
                    display: "flex",
                    flexWrap: "nowrap",
                    __flexGap: "10px",
                    alignItems: "flex-start",
                    flexDirection: "row",
                    justifyContent: "center",
                  },
                  "style@sm": {
                    display: "flex",
                    flexWrap: "nowrap",
                    flexDirection: "column",
                  },
                },
              },
              "09fad59d-d44b-4770-9633-9cb2b0a9b546": {
                props: {
                  style: {
                    color: null,
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: null,
                    borderTopStyle: "none",
                    borderTopWidth: null,
                    backgroundColor: "#14433DFF",
                    borderLeftColor: null,
                    borderLeftStyle: "none",
                    borderLeftWidth: null,
                    borderRightColor: null,
                    borderRightStyle: "none",
                    borderRightWidth: null,
                    borderBottomColor: null,
                    borderBottomStyle: "none",
                    borderBottomWidth: null,
                  },
                },
              },
              "4fd88fdf-a2d3-41fd-bcae-4ab18bb490c0": {
                props: {
                  text: "<p>Save 15% on every subscription</p>",
                  style: {
                    color: "#14433DFF",
                    width: "auto",
                    flexGrow: 1,
                    fontSize: "10px",
                    fontFamily: null,
                    fontWeight: "400",
                    lineHeight: "14px",
                  },
                },
              },
              "4ab82a6f-822a-4b95-979f-9f94b0bdbf27": {
                props: {
                  style: {
                    color: "#000000FF",
                    height: "auto",
                    __alchemyGradient__color__tilt: null,
                    __alchemyGradient__color__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
              "5ca852cf-8882-4943-9044-d3f978f21bc2": {
                props: {
                  style: {
                    width: "auto",
                    height: "auto",
                    display: "flex",
                    flexGrow: 1,
                    alignSelf: "auto",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                  "style@sm": {
                    height: "auto",
                    flexGrow: 1,
                    flexBasis: "auto",
                  },
                },
              },
              "75ba6779-cf5a-4d8d-80d5-aa9c1637bdb9": {
                props: {
                  text: "<p>Free shipping in the contiguous US</p>",
                  style: {
                    width: "auto",
                    flexGrow: 1,
                    fontSize: "10px",
                    fontFamily: null,
                    fontWeight: "400",
                    lineHeight: "14px",
                  },
                },
              },
              "790fb7c2-56e2-49d2-8dd4-ea049322fd1e": {
                props: {
                  style: {
                    maxWidth: "20px",
                    __imageSource:
                      "https://cdn.shopify.com/s/files/1/0771/0860/9337/files/icon_-_cancel_anytime.png?v=1731235197",
                    __imageAltText:
                      "I'm sorry, I can't access URLs directly. Could you please describe the image?",
                  },
                  loading: "lazy",
                },
              },
              "9131627d-320c-425c-89ad-919f031e80a7": {
                props: {
                  text: "<p>No commitment, cancel anytime</p>",
                  style: {
                    width: "auto",
                    flexGrow: 1,
                    fontSize: "10px",
                    fontFamily: null,
                    fontWeight: "400",
                    lineHeight: "14px",
                  },
                },
              },
              "30395ae4-cfcd-4d73-a382-e9339a49b2f7": {
                props: {
                  style: {
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: null,
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    letterSpacing: "0px",
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "1px",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                  },
                },
              },
              "b2286d50-8be5-4c69-a860-8a12ac7373a4": {
                props: {
                  style: {
                    color: null,
                    cursor: "pointer",
                    display: "flex",
                    __flexGap: "16px",
                    alignItems: "flex-start",
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    justifyContent: "space-between",
                    backgroundColor: "#F6F6F6FF",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                    __alchemyGradient__backgroundColor__tilt: null,
                    __alchemyGradient__backgroundColor__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
              "a6c9b44a-956a-4dd1-9951-9f7166f48d5e": {
                props: {
                  style: {
                    width: "auto",
                    height: "auto",
                    display: "flex",
                    flexGrow: 1,
                    alignSelf: "auto",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                  "style@sm": {
                    height: "auto",
                    flexGrow: 1,
                    flexBasis: "auto",
                  },
                },
              },
              "ac184ac7-e5fc-4785-aec8-61d12e571ce3": {
                props: {
                  style: {
                    display: "flex",
                    __flexGap: "10px",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  },
                },
              },
              "f88344ad-f91d-4126-a41d-c6d47cecfa5d": {
                props: {
                  style: {
                    color: "#000000FF",
                    width: "auto",
                    flexGrow: "unset",
                    __alchemyGradient__color__tilt: null,
                    __alchemyGradient__color__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
              "cf3c6f40-c047-4ee5-a405-28d6c4737690": {
                props: {
                  style: {
                    width: "auto",
                    height: "auto",
                    display: "flex",
                    flexGrow: 1,
                    __flexGap: "8px",
                    alignSelf: "auto",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                  "style@sm": {
                    height: "auto",
                    flexGrow: 1,
                    flexBasis: "auto",
                  },
                },
              },
              "ddaeb4bb-6885-4fd4-b609-db2f71cdf2ad": {
                props: {
                  style: {
                    maxWidth: "20px",
                    __imageSource:
                      "https://cdn.shopify.com/s/files/1/0771/0860/9337/files/icon_-_free_shipping.png?v=1731235197",
                    __imageAltText:
                      "I'm sorry, I can't view or access content from URLs.",
                  },
                  loading: "lazy",
                },
              },
              "01036097-337b-456d-a603-ca406405a28c": {
                props: {
                  style: {
                    color: "#14433DFF",
                    right: "8px",
                    width: "20px",
                    height: "20px",
                    __width: "20px",
                    __height: "20px",
                    flexGrow: "unset",
                    position: "absolute",
                  },
                },
              },
              "a5eed9b0-7dbd-44cb-99a6-fc11a1a42ef2": {
                props: {
                  style: {
                    display: "flex",
                    backgroundColor: "#FFFFFFFF",
                  },
                  "style@md": {
                    display: "flex",
                  },
                  "style@sm": {
                    display: "flex",
                  },
                },
              },
            },
          },
          "d05ee808-feb8-4332-9c36-d89b92332215": {
            componentOverrides: {
              "b2286d50-8be5-4c69-a860-8a12ac7373a4": {
                props: {
                  style: {
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#656565FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "2px",
                    borderLeftColor: "#656565FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "2px",
                    borderRightColor: "#656565FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "2px",
                    borderBottomColor: "#656565FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2px",
                    backgroundColor: "#F6F6F6FF",
                    __alchemyGradient__backgroundColor__tilt: null,
                    __alchemyGradient__backgroundColor__stops: null,
                    __reploGradient__color__design_library: null,
                  },
                },
              },
            },
          },
        },
      },
    ],
  },
};
